import { create } from 'zustand';
import { CustomerPortalUrlData, PlanData, ProductData } from '../dto/EntityRepository';

const FIVE_MIN_MS = 5 * 60 * 1000;
// const FIVE_SEC_MS = 5 * 1000;

interface PaymentState {
  product: ProductData | null;
  setProduct: (product: ProductData) => void;
  currentPlan: PlanData | null;
  setCurrentPlan: (currentPlan: PlanData) => void;
  customerPortalUrl: CustomerPortalUrlData | null;
  setCustomerPortalUrl: (url: string) => void;
  isPortalFresh: () => boolean;
}

export const usePaymentStore = create<PaymentState>((set, get) => ({
  product: null,
  setProduct: (product: ProductData) => set({ product }),
  currentPlan: null,
  setCurrentPlan: (currentPlan: PlanData) => set({ currentPlan }),
  customerPortalUrl: null,
  setCustomerPortalUrl: (url) =>
    set({
      customerPortalUrl: {
        url,
        // 5 분이나 실제 만료 중 더 이른 쪽을 선택 (안전 버퍼 30초)
        expiresAt: Date.now() + FIVE_MIN_MS,
      },
    }),
  isPortalFresh: () => {
    const data = get().customerPortalUrl;
    return !!data && Date.now() < data.expiresAt;
  },
}));